<template>
    <label class="radio-container">
        <div class="radio-check-container">
            <input
                type="radio"
                class="qt-radio custom-radio"
                v-bind="$attrs"
                :checked="checked === $attrs.value"
                v-on:change="$emit('change', $event.target.value)" />
            <span class="custom-radio--checkmark"></span>
        </div>
        <div class="radio-text">
            <slot></slot>
        </div>
    </label>
</template>

<script>
    export default {
        name: 'RadioboxElm',
        inheritAttrs: false,
        model: {
            prop: 'checked',
            event: 'change',
        },
        props: {
            checked: {
                type: String | Number,
            },
        },
    };
</script>
